import angular from 'angular';
import confirmUnlinkGmailSync from './confirmUnlinkGmailSync';

export default angular
  .module('components.confirmUnlinkedGmailSyncModal', [])
  .component('confirmUnlinkGmailSync', confirmUnlinkGmailSync).name;
